import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import MembershipCard from "@/components/membershipCard/membershipCard.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  components: {
    HomeNavBar,
    MembershipCard,
  },
  computed: {
    active_membership_plans() {
      return this.membershipPlans.filter(plan => plan.is_active);
    },
    current_membership_label() {
      return this.current_membership?.membership_type?.name || this.current_membership?.name || '';
    },
    view_membership_loading() {
      return this.memberships_loading || this.payment_history_loading || this.billing_loading;
    },
    should_open_manage_subscription() {
      return this.$route.query.manage_subscription === '1';
    },
    selected_membership_plan() {
      if (this.selectedPlan === null || this.selectedPlan === '') {
        return null;
      }
      return this.active_membership_plans[this.selectedPlan] || null;
    }
  },
  mounted() {
    this.fetch_memberships();
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filter_membership_payment_history();
    this.fetch_my_billing();
  },
  data() {
    return ({
      user: this.getUserData(),
      currentStepIndex: 0,
      token_exists: false,
      steps: [
        { label: 'Membership' },
        { label: 'Payment' },
      ],
      selectedPlan: null,
      expandedPerks: {},
      memberships_loading: true,
      payment_history_loading: true,
      billing_loading: true,
      billing_summary: {
        currency: 'ZAR',
        outstanding_total: '0.00',
        has_outstanding: false,
        subscriptions: [],
        invoices: [],
      },
      invoice_payment_reference: null,
      manage_subscription_opened: false,
      membershipPlans: [],
      total_paid_users: {},
      current_membership: null,
      upgrade_quote: null,
      upgrade_quote_loading: false,
      payment_submitting: false,
      payfast: process.env.VUE_APP_PAYFAST_URL
    });
  },
  watch: {
    view_membership_loading(isLoading) {
      if (!isLoading) {
        this.open_manage_subscription_if_needed();
      }
    }
  },
  methods: {
    get_membershipcard() {
      $('#manage_subscription_modal').modal('hide');
      return this.$refs.membership_card?.get_membershipcard();
    },
    getUserData() {
      let user = {
        first_name: '',
        last_name: '',
        email: '',
        gender_id: '',
        date_of_birth: '',
        phone_number: '',
        user_id: '',
        newSkill: ''
      }
      return user;
    },
    getToken() {
      return get_token();
    },
    format_currency(amount) {
      const value = Number(amount || 0);
      return `R ${value.toLocaleString('en-ZA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    format_display_date(value) {
      if (!value) {
        return '-';
      }
      return new Date(value).toLocaleDateString('en-ZA', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    },
    get_prorated_plan_cost(daily_cost) {
      return Number(daily_cost || 0) * Number(this.upgrade_quote?.remaining_days || 0);
    },
    get_upgrade_perks() {
      return (this.selected_membership_plan?.membership_perks || []).slice(0, 3);
    },
    get_payment_status(payment) {
      return String(payment?.payment_status?.status || '').toLowerCase();
    },
    resolve_current_membership(history = []) {
      const currentEntry =
        history.find((payment) => this.get_payment_status(payment) === 'paid' && payment?.is_active);
      return currentEntry?.membership || null;
    },
    billing_status_label(status) {
      return String(status || '').replaceAll('_', ' ');
    },
    billing_status_class(status) {
      if (status === 'paid' || status === 'active') return 'bg-success';
      if (status === 'open') return 'bg-primary';
      if (status === 'past_due' || status === 'suspended') return 'bg-danger';
      return 'bg-secondary';
    },
    fetch_my_billing() {
      this.token_exists = get_token();
      if (!this.token_exists) {
        this.billing_loading = false;
        return;
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/my_billing/`,
        method: 'GET',
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.billing_summary = response?.data || this.billing_summary;
        },
        error: () => {
          this.billing_summary = {
            currency: 'ZAR',
            outstanding_total: '0.00',
            has_outstanding: false,
            subscriptions: [],
            invoices: [],
          };
        },
        complete: () => {
          this.billing_loading = false;
        },
      });
    },
    pay_membership_invoice(invoice) {
      if (!invoice?.reference || !invoice?.payable || this.invoice_payment_reference) return;
      this.invoice_payment_reference = invoice.reference;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/invoices/${invoice.reference}/pay/`,
        method: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({}),
        success: (response) => this.submit_payfast_form(response?.data_array || {}),
        error: (error) => {
          Swal.fire({
            title: 'Unable to start payment',
            text: this.get_api_error_message(error, 'Please refresh and try again.'),
            icon: 'error',
          });
        },
        complete: () => {
          this.invoice_payment_reference = null;
        },
      });
    },
    has_matching_id(candidate_id, current_membership_id) {
      return Boolean(candidate_id && current_membership_id && candidate_id === current_membership_id);
    },
    has_same_membership_id(plan) {
      return this.has_matching_id(plan?.id, this.current_membership?.id);
    },
    has_same_membership_type(plan) {
      return this.has_matching_id(plan?.membership_type?.id, this.current_membership?.membership_type?.id);
    },
    has_same_billing_cycle(plan) {
      return this.has_matching_id(plan?.billing_cycle?.id, this.current_membership?.billing_cycle?.id);
    },
    has_same_membership_terms(plan) {
      return this.has_same_membership_type(plan) && this.has_same_billing_cycle(plan);
    },
    is_current_plan(plan) {
      return this.has_same_membership_id(plan) || this.has_same_membership_terms(plan);
    },
    get_membership_subscriber_count(plan) {
      return Number(Reflect.get(this.total_paid_users, plan?.id) || 0);
    },
    get_popular_plan_id() {
      const plans_with_counts = this.active_membership_plans
        .map((plan) => ({
          id: plan.id,
          subscribers: this.get_membership_subscriber_count(plan),
        }))
        .filter((plan) => plan.id);

      if (!plans_with_counts.length) {
        return null;
      }

      const max_subscribers = Math.max(...plans_with_counts.map((plan) => plan.subscribers));
      if (max_subscribers <= 0) {
        return null;
      }

      const most_popular_plans = plans_with_counts.filter((plan) => plan.subscribers === max_subscribers);
      return most_popular_plans.length === 1 ? most_popular_plans[0].id : null;
    },
    is_popular_plan(plan) {
      return Boolean(plan?.id && plan.id === this.get_popular_plan_id());
    },
    is_upgrading_membership() {
      return Boolean(
        this.current_membership &&
        this.selected_membership_plan &&
        !this.is_current_plan(this.selected_membership_plan)
      );
    },
    get_membership_payment_url() {
      const endpoint = this.is_upgrading_membership()
        ? 'upgrade_membership'
        : 'create_payfast_membership_payment';

      return `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/${endpoint}/`;
    },
    get_payment_form_data(response = {}) {
      return response?.data_array || {};
    },
    submit_payfast_form(data_array = {}) {
      if (!this.payfast || !Object.keys(data_array).length) {
        Swal.fire({
          title: 'Unable to redirect',
          text: 'PayFast checkout details are unavailable. Please try again.',
          icon: 'error',
        });
        return;
      }

      $('#membership_upgrade_confirmation_modal').modal('hide');
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = this.payfast;
      form.style.display = 'none';

      for (const [key, value] of Object.entries(data_array)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value ?? '';
        form.appendChild(input);
      }

      document.body.appendChild(form);
      Swal.fire({
        title: 'Success',
        icon: 'success',
        text: "Redirecting to PayFast in a few seconds don't close this page",
        confirmButtonText: 'Ok',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      HTMLFormElement.prototype.submit.call(form);
    },
    handle_membership_payment_success(response) {
      if (this.is_upgrading_membership()) {
        this.submit_payfast_form(response?.data_array || {});
        return;
      }

      if (!response.success) {
        return;
      }

      this.submit_payfast_form(this.get_payment_form_data(response));
    },
    get_visible_perks(plan) {
      const perks = plan?.membership_perks || [];
      return Reflect.get(this.expandedPerks, plan.id) ? perks : perks.slice(0, 5);
    },
    toggle_perks(planId) {
      const expanded_perks = { ...this.expandedPerks };
      const current_value = Boolean(Reflect.get(this.expandedPerks, planId));
      Reflect.set(expanded_perks, planId, !current_value);
      this.expandedPerks = expanded_perks;
    },
    open_manage_subscription_if_needed() {
      if (!this.should_open_manage_subscription || !this.current_membership || this.manage_subscription_opened) {
        return;
      }
      this.manage_subscription_opened = true;
      $('#manage_subscription_modal').modal('show');
    },
    open_upgrade_confirmation_modal() {
      $('#membership_upgrade_confirmation_modal').modal('show');
    },
    close_upgrade_confirmation_modal() {
      $('#membership_upgrade_confirmation_modal').modal('hide');
    },
    selectPlan(index) {
      this.selectedPlan = index;
      this.upgrade_quote = null;
      if (!this.is_upgrading_membership()) {
        this.nextStep();
        return;
      }
      this.preview_membership_upgrade();
    },
    get_api_error_message(error, fallback) {
      const message = error?.responseJSON?.message;
      if (typeof message === 'string') {
        return message;
      }
      return fallback;
    },
    preview_membership_upgrade() {
      this.upgrade_quote_loading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/preview_membership_upgrade/`,
        method: 'POST',
        data: JSON.stringify({
          membership_id: this.selected_membership_plan.id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          this.upgrade_quote = response?.data || null;
          this.open_upgrade_confirmation_modal();
        },
        error: (error) => {
          Swal.fire({
            title: 'Unable to upgrade',
            text: this.get_api_error_message(
              error,
              'This membership is not a higher-cost upgrade.',
            ),
            icon: 'error',
          });
          this.selectedPlan = null;
        },
        complete: () => {
          this.upgrade_quote_loading = false;
        },
      });
    },
    selectPaymentMethod(index) {
      this.selectedPaymentMethod = index;
    },
    nextStep() {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex++;
      }
    },
    prevStep() {
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
      }
    },
    cancel() {
      // Navigate back to customer profile page
      this.$router.push('/profile');
    },
    completePayment() {
      if (!this.selected_membership_plan) {
        Swal.fire({
          title: 'Please select a plan before proceeding.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const membership_id = this.selected_membership_plan.id;
      this.payment_submitting = true;

      $.ajax({
        url: this.get_membership_payment_url(),
        method: 'POST',
        data: JSON.stringify({
          membership_id: membership_id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          this.handle_membership_payment_success(response);
        },
        error: (error) => {
          console.error('AJAX error:', error);
          Swal.fire({
            title: 'Error',
            text: this.get_api_error_message(
              error,
              'Payment failed. Please try again later.',
            ),
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.payment_submitting = false;
        }
      });
    },

    fetch_memberships() {
      this.token_exists = get_token();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify({ is_active: true }),
        success: (response) => {
          this.membershipPlans = response.data.memberships;
          this.fetch_membership_subscriber_counts();
        },
        complete: () => {
          this.memberships_loading = false;
        },
      });
    },
    fetch_membership_subscriber_counts() {
      this.active_membership_plans.forEach((membership) => {
        this.fetch_membership_subscriber_count(membership.id);
      });
    },
    fetch_membership_subscriber_count(membership_id) {
      if (!membership_id) {
        return;
      }

      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/total_paid_users_per_membership/?membership_id=${membership_id}`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.total_paid_users = {
            ...this.total_paid_users,
            [membership_id]: response.total_paid_users,
          };
        },
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.current_membership = this.resolve_current_membership(this.membership_payment_history);

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => this.get_payment_status(payment) === "paid" && payment?.is_active
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name = this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until || null;
        },
        complete: () => {
          this.payment_history_loading = false;
        },
      })
    },
    go_back() {
            this.$router.back();
        },
  }
}